export const METHOD_CONSTANTS = {
  evidenceTarget: 10,
  matureAgeFrom: 6,
  matureAgeTo: 24,
  matureHistoryMonths: 36,
  steadyRun: 6,
  tailStartAge: 12,
  qaPercentile: 99,
  autoWindow: 12
};

export type MethodConstantKey = keyof typeof METHOD_CONSTANTS;

export const METHOD_CONSTANT_LIMITS: Record<MethodConstantKey, [number, number]> = {
  evidenceTarget: [1, 1000],
  matureAgeFrom: [1, 120],
  matureAgeTo: [1, 120],
  matureHistoryMonths: [1, 240],
  steadyRun: [1, 60],
  tailStartAge: [1, 120],
  qaPercentile: [50, 100],
  autoWindow: [3, 12]
};

export const GUARD_STRUCTURE = {
  k: 3,
  trendWindow: 12,
  trendBands: [1, 2, 4, 7, 13, 25],
  trendApplications: 1,
  tailWindow: 12,
  legacyCeiling: 1
};
